import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=72a043da&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=72a043da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a043da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a043da')) {
      api.createRecord('72a043da', component.options)
    } else {
      api.reload('72a043da', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=72a043da&scoped=true&", function () {
      api.rerender('72a043da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iJ0FwAMOH3Ye/JS/comp/SearchFilterTokens.vue"
export default component.exports